import React from "react";
import PropTypes from "prop-types"

const USD = props => {
  return (
    <span className={props.className}>
      ${props.space ? " " : ""}{props.val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}
    </span>
  )
}

USD.propTypes = {
  val: PropTypes.number.isRequired
}

export default USD
